import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import {
    Image,
    View,
    TouchableOpacity,
    StyleSheet,
    FlatList
} from 'react-native';

import {
    JDText,
    JDImage,
    JDTouchable
} from '@jdreact/jdreact-core-lib'

import { pt, mta, is_web } from '../../common/utils';
import img from '../../common/img';

import LinearGradient from '@jdreact/jdreact-core-linear-gradient';
class HotTop extends PureComponent {

    constructor(props) {
        super(props);
        this.toMoreMovie = this.toMoreMovie.bind(this);
        this.render_hotItem = this.render_hotItem.bind(this);
        this.render_hotBottom = this.render_hotBottom.bind(this);
    }
    _scroll;

    render() {
        let { movieType, hotMovie, mostExpectList } = this.props;
        let hotMovieCopy = hotMovie.slice(0, 12);
        let mostExpectListCopy = mostExpectList.slice(0, 12);
        return (
            <View style={st.hot_top_wrap}>
                <FlatList
                    data={movieType == 1 ? hotMovieCopy : mostExpectListCopy}
                    keyExtractor={(item, index) => index + ''}
                    horizontal={true}
                    initialNumToRender={4}
                    ref={(scroll) => this._scroll = scroll}
                    contentContainerStyle={st.movie_list_wrap}
                    showsHorizontalScrollIndicator={false}
                    renderItem={this.render_hotItem}
                    ListHeaderComponent={() => {
                        return (
                            <View style={{width: pt(15), height: '100%'}}/>
                        )
                    }}
                    ListFooterComponent={this.render_hotBottom}
                    ListEmptyComponent={() => {
                        return (
                            <View style={{height: pt(192), width: pt(478)}}>
                                <JDImage style={{height: pt(192), width: pt(478)}} source={img.hot_top_load}></JDImage>
                            </View>
                        )
                    }}
                >
                </FlatList>
                </View>
        );
    }

    componentDidUpdate() {
        this._scroll && this._scroll.scrollToOffset({animated: false, offset: 0});
    }

    render_hotItem({item, index}) {
        let { movieType, cityId } = this.props;
        let mostExpectListCopy = this.props.mostExpectList.slice(0, 12);
        if (movieType == 1) {
            return (
                <View style={st.movie}>
                    <TouchableOpacity
                        onPress={() => {
                            mta('HomeTopMovPic', 'Home', `${item.jSkuId}_${item.movieId}_${!!item.showType ? item.showType : ''}_${item.weight}`);
                            // if(is_web) {
                            //     location.href = `https://m-movie.jd.com/va/movieInfoNew/${item.movieId}?jdreactkey=JDReactMovie&jdreactapp=JDReactMovie&rn_transparentenable=true&rn_routerName=movieDetail&rn_movieId=${item.movieId}`;
                            // } else {
                                this.context.router.toMovieDetail({ movieId: item.movieId });
                            // }
                        }}
                        activeOpacity={0.5}
                    >
                        <View style={st.movie_top}>
                            <Image
                                style={st.movie_top_img}
                                source={{ uri: item.jdPicUrl }}
                            >
                            </Image>
                            <LinearGradient colors={['rgba(255,255,255,0)','#000']} style={{height: pt(50),position:'absolute',bottom:0,width:pt(90),borderRadius:pt(5),opacity:0.8}} />
                            {!!item.showType &&
                                <View style={st.movie_type_wrap}>
                                    <JDText style={st.movie_type}>{item.showType}</JDText>
                                </View>
                            }
                            {item.canPreOrder === 2 ?
                                <JDText style={st.movie_score}>{!!item.grade ? '观众评分' + item.grade : '暂无评分'}</JDText> :
                                <JDText style={st.movie_score}>{item.like}人想看</JDText>
                            }
                        </View>
                    </TouchableOpacity>
                    <View style={st.movie_middle}>
                        <JDText numberOfLines={1} style={st.movie_middle_text}>{item.movieName}</JDText>
                    </View>
                    <TouchableOpacity style={[st.to_buy_wrap, is_web && {borderRadius: pt(6), overflow: 'hidden'}]}
                        onPress={() => {
                            mta('HomeTopMovBuy', 'Home', `${item.existPromtion ? '特惠' : item.canPreOrder === 2 ? '购票' : '预售'}_${item.weight}`);
                            // if(is_web) {
                            //     location.href = `https://m-movie.jd.com/va/movieNew/${cityId}/${item.movieId}?jdreactkey=JDReactMovie&jdreactapp=JDReactMovie&rn_transparentenable=true&rn_routerName=movieSchedule&rn_movieId=${item.movieId}`;
                            // }else {
                            this.toBuy(item.movieId);
                            // }
                        }}
                    >
                        <JDImage style={st.to_buy_button} resizeMode='contain' source={item.existPromtion ? img.discount : item.canPreOrder === 2 ? img.go_buy : img.preSale}></JDImage>
                        <View style={st.to_buy_text_wrap}>
                            <JDText style={[st.to_buy_text, is_web && isAndroid && {marginTop: pt(4)}]}>{item.existPromtion ? '特惠' : item.canPreOrder === 2 ? '购票' : '预售'}</JDText>
                        </View>
                    </TouchableOpacity>
                </View>
            )
        }
        if (movieType == 2) {
            return (
                <JDTouchable
                    onPress={() => {
                        mta('HomeExpectPic', 'Home', `${item.jSkuId}_${item.movieId}_${!!item.showType ? item.showType : ''}_${item.weight}`);
                        // if(is_web) {
                        //     location.href = `https://m-movie.jd.com/va/movieInfoNew/${item.movieId}?jdreactkey=JDReactMovie&jdreactapp=JDReactMovie&rn_transparentenable=true&rn_routerName=movieDetail&rn_movieId=${item.movieId}&rn_cityId=${cityId}`;
                        // } else {
                        this.context.router.toMovieDetail({ movieId: item.movieId });
                        // }
                    }}
                    activeOpacity={0.5}
                >
                    <View style={[st.movie, (index == mostExpectListCopy.length - 1) && st.no_margin_right]}>
                        <View style={st.movie_top}>
                            <Image
                                style={st.movie_top_img}
                                source={{ uri: item.jdPicUrl }}
                            >
                            </Image>
                            <LinearGradient colors={['rgba(255,255,255,0)','#000']} style={{height: pt(50),position:'absolute',bottom:0,width:pt(90),borderRadius:pt(5),opacity:0.8}} />
                            {!!item.showType &&
                                <View style={st.movie_type_wrap}>
                                    <JDText style={st.movie_type}>{item.showType}</JDText>
                                </View>
                            }
                            <JDText style={st.movie_score}>{item.like}人想看</JDText>
                        </View>
                        <View style={st.movie_middle}>
                            <JDText numberOfLines={1} style={st.movie_middle_text}>{item.movieName}</JDText>
                        </View>
                        <JDText style={st.show}>{item.releaseDate}</JDText>
                    </View>
    
                </JDTouchable>
            )
        }
    }

    render_hotBottom() {
        let { hotMovie, movieType } = this.props;
        if (hotMovie.length == 0 || movieType !== 1) {
            return <View style={{width: pt(15), height: '100%'}}/>;
        }
        return (
            <TouchableOpacity onPress={this.toMoreMovie} style={st.movie_all}>
                <JDText style={st.movie_all_text}>全部电影</JDText>
                <JDText style={st.movie_all_text}>{hotMovie.length}部</JDText>
            </TouchableOpacity>
        )
    }

    toMoreMovie() {
        mta('HomeAllMov', 'Home');
        this.context.router.toAllMovie();
    }

    toBuy(movieId) {
        this.context.router.toMovieSchedule({ movieId });
    }
}

HotTop.contextTypes = {
    router: PropTypes.object
};

HotTop.propTypes = {
    hotMovie: PropTypes.array.isRequired,
    movieType: PropTypes.number.isRequired
}

const st = StyleSheet.create({
    hot_top_wrap: {
        backgroundColor: '#fff',
        paddingBottom: pt(21),
        height: pt(214)
    },
    top: {
        height: pt(24),
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    top_left: {
        fontSize: pt(17),
        marginLeft: pt(8),
        fontWeight: 'bold'
    },
    top_right: {
        height: pt(22),
        width: pt(235),
        backgroundColor: 'rgba(240,246,255,1)',
        borderRadius: pt(2),
        marginRight: pt(8),
        justifyContent: 'center'
    },
    top_right_text: {
        color: '#2B84FF',
        fontSize: pt(10),
        flex: 1,
        alignItems: 'center'
    },
    movie_list_wrap: {
        // paddingLeft: pt(15),
        // paddingRight: pt(15),
        // marginTop: pt(10),
    },
    movie: {
        width: pt(90),
        marginRight: pt(8),
    },
    movie_top: {
        height: pt(132),
        overflow: 'hidden',
        justifyContent: 'center',

    },
    movie_top_img: is_web ?  {
        width: pt(90),
        height: pt(132),
        borderRadius: pt(3)
    } : {
        height: '100%',
        width: '100%',
        borderRadius: pt(3)
    }  ,
    movie_type_wrap: {
        backgroundColor: '#fff',
        borderRadius: pt(3),
        paddingHorizontal: pt(3),
        position: 'absolute',
        top: pt(3),
        left: pt(3),
    },
    movie_type: {
        fontSize: pt(11),
        color: '#252525'
    },
    movie_score: {
        backgroundColor: 'transparent',
        position: 'absolute',
        bottom: pt(3),
        left: pt(3),
        color: '#FFAE18',
        fontSize: pt(11)
    },
    movie_middle: {
        height: pt(20),
        justifyContent: 'center',
        marginTop: pt(6),
    },
    movie_middle_text: {
        fontSize: pt(14)
    },
    to_buy_wrap: {
        position: 'relative',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: pt(8),
        width: pt(53)
    },
    to_buy_button: {
        width: pt(53),
        height: pt(27)
    },
    to_buy_text_wrap: {
        position: 'absolute',
        height: '100%',
        width: '100%',
        top: 0,
        left: 0,
        alignItems: 'center',
        justifyContent: 'center'
    },
    to_buy_text: {
        backgroundColor: 'transparent',
        color: '#fff'
    },
    movie_all: {
        height: pt(132),
        width: pt(90),
        backgroundColor: '#ECECEC',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: pt(3),
        marginRight: is_web ? pt(15) : 0
    },
    movie_all_text: {
        color: '#898989',
        fontSize: pt(12)
    },
    show: {
        color: '#666666',
        fontSize: pt(12),
        marginTop: pt(2)
    },
    no_margin_right: {
        marginRight: 0
    }
})

export default HotTop;
